import React from "react";
import ErrorLabel from "./ErrorLabel";
import { ErrorMessage } from "formik";

const FieldError = (props) => {
    return <ErrorMessage {...props} component={ErrorLabel} />
};

export default FieldError;
